<template>
  <div style="width:100%;height:100%;">
    <div class="userratio">
      <div class="top">
        <div
          class="left"
          v-for="(item,index) in arr"
          :class="[{'dianji': arrkey==item}]"
          :key="index"
          @click="cutkey(item)"
        >{{item}}</div>
      </div>
      <div class="bottom">
        <div id="echarts31" :style="charts31Style"></div>
        <div class="tab-switch">
          <span
            v-for="item in tabData"
            :class="[{'current': tabKey==item}]"
            v-text="item"
            :key="item"
            @click="tabSwitch(item)"
          ></span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "echarts31",
  props: {
    charts31Style: {
      type: Object,
      default: () => {
        return { width: "100%", height: "100%", position: "relative" };
      }
    },
    xData31: {
      type: Array,
      default: () => {
        return ["货架1", "货架2", "货架3", "货架4", "货架5", "货架6"];
      }
    },
    legendData31: {
      type: Array,
      default: () => {
        return ["总流量", "入库", "出库"];
      }
    },
    datagather31: {
      type: Array,
      default: () => {
        return [
          [40, 64, 52, 58, 62, 60],
          [30, 22, 41, 44, 41, 10],
          [10, 42, 11, 14, 21, 50]
        ];
      }
    }
  },
  data() {
    let arr = ["利用率", "周转率"];
    let tabData = ["库区", "巷道", "货位"];
    return {
      arr: arr,
      arrkey: arr[0],
      tabData: tabData,
      tabKey: tabData[0]
    };
  },
  mounted() {
    this.pies();
  },
  methods: {
    //大选项卡
    cutkey(item) {
      this.arrkey = item;
      this.$emit("echarts31key", item);
    },
    //小选项卡
    tabSwitch(item) {
      //   console.log(item);
      this.tabKey = item;
      //   this.getGzsjhzList();
      this.$emit("receive32data", item);
    },
    //echart表
    pies() {
      let _this = this;
      var behaviorpie = this.$echarts.init(
        document.getElementById("echarts31")
      );
      let option = {
        color: ["#0162EA", "#1EDFCE", "#8F5BFE"],
        title: {
          // text: '2016年12月长宁区合规成本分析'
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        legend: {
          // show:true,
          data: _this.legendData31,
          left: 10,
          top: 60,
          icon: "circle",
          itemWidth: 8, // 图例图形宽度
          itemHeight: 8, // 图例图形高度
          textStyle: {
            color: ["#5F45FF", "#02CDFF", "#0190FF", "#314975"]
          }
        },
        grid: {
          left: "1%",
          right: "4%",
          bottom: "3%",
          top: "35%",
          containLabel: true
        },
        calculable: true,
        xAxis: [
          {
            type: "category",
            axisLabel: {
              textStyle: {
                fontSize: 12,
                color: "#000"
              }
            },
            axisLine: {
              lineStyle: {
                color: "#000",
                width: 1
              }
            },
            axisTick: {
              show: false
            },
            // splitLine: {
            //     lineStyle: {
            //         type: 'dashed',
            //         color: '#DDD'
            //     }
            // },
            data: _this.xData31
          }
        ],
        yAxis: [
          {
            type: "value",
            color: "#000",
            minInterval: 1,
            boundaryGap: [0, 0.3],
            nameTextStyle: {
              color: "#000",
              padding: [2, 0, 0, 20]
            },
            axisLabel: {
              formatter: "{value}%",
              color: "#000",
              fontSize: 10
            },
            axisLine: {
              show: true,
              lineStyle: {}
            },
            axisTick: {
              //y轴刻度
              show: false
            },
            splitLine: {
              lineStyle: {    // 刻度线
                // type: "solid",
                // color: "#324969"
              }
            }
          }
        ],
        series: [
          {
            name: _this.legendData31[0],
            type: "bar",
            barWidth: 8, //柱子宽度
            barGap: 0.5, //柱子之间间距
            itemStyle: {},
            data: _this.datagather31[0]
          },
          {
            name: _this.legendData31[1],
            type: "bar",
            barWidth: 8, //柱子宽度
            barGap: 0.5, //柱子之间间距
            itemStyle: {},
            data: _this.datagather31[1]
          },
          {
            name: _this.legendData31[2],
            type: "bar",
            barWidth: 8, //柱子宽度
            barGap: 0.5, //柱子之间间距
            itemStyle: {},
            data: _this.datagather31[2]
          }
        ]
      };
      behaviorpie.setOption(option);
    }
  }
};
</script>
<style scoped>
.userratio {
  /* width: 374px;
  height: 340px; */
  width: 100%;
  height: 100%;
  position: relative;
}
.top {
  height: 38px;
  width: 100%;
  /* box-shadow: inset 2px  #065457 */
  display: flex;
  /* border:  3px  solid #009585 */
}
.left {
  width: 50%;
  height: 34px;
  background: #072132;
  /* border: 2px solid #009585; */
  line-height: 32px;
  color: #1edecf;
  text-align: center;
}
.dianji {
  background: #01665e;
  color: #fff;
}
.bottom {
  width: 100%;
  height: calc(100% - 34px);
  /* border: 1px solid #0f5b68; */
}
.tab-switch {
  width: 240px;
  height: 30px;
  position: absolute;
  right: 40px;
  top: 56px;
}
.tab-switch span {
  color: #fff;
  font-size: 14px;
  text-align: center;
  width: 40px;
  padding: 3px;
  margin: 0px 10px;
  line-height: 24px;
  height: 24px;
  display: inline-block;
  background-color: #1b406d;
  border-radius: 3px;
}
.current {
  background: #07afa0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/xiayan/home/home/echarts31.vue